import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { ChangeRentalObjectCategoryDialogComponent } from '../../component/change-rental-object-category-dialog/change-rental-object-category-dialog.component';
import { RentalObjectCategory } from '../../model/const/enums';
import { ChangeRentalObjectCategoryResponse } from '../data/rental-object-category.service';

@Injectable()
export class ChangeRentalObjectCategoryCommandHandler implements ICommandHandler {
  constructor(
    private readonly dialogService: ActionWindowService,
    private readonly injector: Injector,
    private readonly navigation: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    return command instanceof Command && command.id === rentalObjectCommand.changeCategory && !!command.context?.id;
  }

  execute(command: CommandBase): Observable<boolean> {
    return this.dialogService
      .open(ChangeRentalObjectCategoryDialogComponent, this.injector, null, (command as Command).context)
      .pipe(
        map((response: ChangeRentalObjectCategoryResponse) => {
          this.afterChange(response, (command as Command).context.id);
          return !!response;
        })
      );
  }

  private afterChange(response: ChangeRentalObjectCategoryResponse, id: string): void {
    if (!response) return;
    if (!this.navigation.parameterLessUrl.includes('/edit/')) return;
    const routeSegments = {
      [RentalObjectCategory.Dwelling]: ['my-property', 'dwelling'],
      [RentalObjectCategory.Premises]: ['my-property', 'premises'],
      [RentalObjectCategory.Parking]: ['my-property', 'parking'],
      [RentalObjectCategory.Other]: ['my-property', 'other-rental-object'],
    }[response.category];
    if (!routeSegments) return;
    this.navigation.navigate([...routeSegments, 'edit', id]);
  }
}
